import { css } from '@emotion/react'
import Image from 'next/image'
import { match } from 'ts-pattern'
import { Button } from 'components/common/Button'
import { styled } from 'styles/styled'

export const ImageViewContainer = styled.div`
  display: grid;
  grid-template-areas:
    'main top-left top-right'
    'main bottom-left bottom-right';
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  margin-top: 12px;
  position: relative;
  width: 100%;
`

export const ImageContainer = styled.div`
  position: relative;
  height: 240px;
  width: 100%;
  &:nth-of-type(1) {
    grid-area: main;
    height: 488px;
    border-radius: 16px 0 0 16px;
  }
  &:nth-of-type(2) {
    grid-area: top-left;
  }
  &:nth-of-type(3) {
    grid-area: top-right;
    border-radius: 0 16px 0 0;
  }
  &:nth-of-type(4) {
    grid-area: bottom-left;
  }
  &:nth-of-type(5) {
    grid-area: bottom-right;
    border-radius: 0 0 16px 0;
  }
  cursor: pointer;
`

export const ButtonCaroussel = styled(Button)`
  position: absolute;
  bottom: 20px;
  right: 20px;
`

interface StyledImageProps {
  $index: number
}

export const StyledImage = styled(Image)<StyledImageProps>(({ $index }) =>
  match($index)
    .with(
      0,
      () => css`
        border-radius: 16px 0 0 16px;
      `
    )
    .with(
      2,
      () => css`
        border-radius: 0 16px 0 0;
      `
    )
    .with(
      4,
      () => css`
        border-radius: 0 0 16px 0;
      `
    )
    .otherwise(() => undefined)
)
